module.exports = __webpack_public_path__ + "static/media/logo136.e0537d01.png";